// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

export type PermissionNames =
    "View Users" | "Manage Users" |
    "Manage Offers" | "Manage Customer Companies" | "Manage Vehicle Configuration" | "Manage Product Configuration" | "Manage Catalog Link" | "Manage Photo Info" |
    "View Roles" | "Manage Roles" | "Assign Roles";

export type PermissionValues =
    "users.view" | "users.manage" |
    "users.manage.offers" | "users.manage.companieReprezentari" | "users.manage.car" | "users.manage.product" | "users.manage.cataloglink" | "users.manage.photo" |
    "roles.view" | "roles.manage" | "roles.assign";

export class Permission {

    public static readonly viewUsersPermission: PermissionValues = "users.view";
    public static readonly manageUsersPermission: PermissionValues = "users.manage";
    public static readonly manageOffersPermission: PermissionValues = "users.manage.offers";
    public static readonly manageCompanieReprezentariPermission: PermissionValues = "users.manage.companieReprezentari";
    public static readonly manageCarPermission: PermissionValues = "users.manage.car";
    public static readonly manageProductPermission: PermissionValues = "users.manage.product";
    public static readonly manageCatalogLinkPermission: PermissionValues = "users.manage.cataloglink";
    public static readonly managePhotoPermission: PermissionValues = "users.manage.photo";

    public static readonly viewRolesPermission: PermissionValues = "roles.view";
    public static readonly manageRolesPermission: PermissionValues = "roles.manage";
    public static readonly assignRolesPermission: PermissionValues = "roles.assign";

    constructor(name?: PermissionNames, value?: PermissionValues, groupName?: string, description?: string) {
        this.name = name;
        this.value = value;
        this.groupName = groupName;
        this.description = description;
    }

    public name: PermissionNames;
    public value: PermissionValues;
    public groupName: string;
    public description: string;
}
